import * as Yup from 'yup';

function schema() {
  return Yup.object().shape({
    productionOrderId: Yup.string().required('Production Order ID is required'),
    scanStatus: Yup.string().required('Scan status is required'),
    haveCurrentSet: Yup.mixed()
      .required('Please indicate if you have a current set')
      .transform((value) => {
        if (value === 'true') {
          return true;
        }
        if (value === 'false') {
          return false;
        }
        return value;
      })
      .test(
        'is-boolean',
        'Please select an option',
        (value) => typeof value === 'boolean',
      ),
    howOftenWear: Yup.string().required(
      'Please indicate how often retainers are worn',
    ),
    userIssue: Yup.string().required('Please select an issue type'),
    arch: Yup.string().required('Please select which retainer'),
    upperArchFit: Yup.string().when('arch', (val, schema) => {
      if (val === 'upper' || val === 'both') {
        return schema.required('Please select how the top retainer fits');
      }
      return schema.notRequired();
    }),
    lowerArchFit: Yup.string().when('arch', (val, schema) => {
      if (val === 'lower' || val === 'both') {
        return schema.required('Please select how the bottom retainer fits');
      }
      return schema.notRequired();
    }),
    message: Yup.string()
      .trim()
      .required('Please provide additional details about the fit issue'),
    warrantyImagesAttributes: Yup.array()
      .of(
        Yup.object().shape({
          fileUrl: Yup.string().required(),
          originalFilename: Yup.string().required(),
          fileType: Yup.string().required(),
        }),
      )
      .min(1, 'Please upload at least one image')
      .required('Please upload at least one image'),
    whereToShip: Yup.string().required('Please select where to ship'),
  });
}

export default schema;
